import React from "react";
import Icon, { IconProps } from "./Icon";

const BedIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 12h18m-9 4.5V16.5m0 0V21m0-4.5h4.5M9 16.5v4.5m0-4.5H4.5M3 12V9a2 2 0 012-2h14a2 2 0 012 2v3M7 7V5a1 1 0 011-1h8a1 1 0 011 1v2"
      />
    </Icon>
  );
};

export default BedIcon;
